import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useAppContext } from "./DashAppContext";

const StyledTabs = styled((props) => (
  <Tabs
      {...props}
      TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  
  '& .MuiTabs-indicator': {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'white',
  },
  '& .MuiTabs-indicatorSpan': {
      width: '100%',
      backgroundColor: '#177bc1',
  },
  '&:hover': {
      color: '#54aeda',
      opacity: 1,
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: "bold",
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(3),
    color: "rgba(0, 0, 0, 0.7)",
    borderRadius: "8px",
    "&.Mui-selected": {
      color: "#177bc1",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "rgba(100, 95, 228, 0.32)",
    },
    "&:hover": {
      color: "#177bc1",
      opacity: 1,
    },
  })
);

const DashboardChillerBar = ({selectedFamilyname}) => {
  const { selectedFamily, setSelectedFamily, setChiller_list, setOpen } =
    useAppContext();
  const [value, setValue] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [executionid, setExecutionid] = useState("Execution Id Latest");
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  useEffect(() => {
    selectedFamilyname("30RB");
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSelectedFamily(event.target.innerText); // Update selected family based on tab label
    setExecutionid("Execution Id Latest");
    selectedFamilyname(event.target.innerText);
  };

  const handleExecutionidChange = (event, newValue) => {
    setExecutionid(newValue);
  };

  //  =======================================    API - START ======================
  //  =======================================    API - END ========================

  return (
    <div
      style={{
        justifyContent: "space-between",
        alignItems: "center",
        position: "relative",
        
      }}
    >
      <Box
        sx={{
          marginLeft: "2rem",
          marginTop: "1.5rem",
          width: "95%",
          height:"4rem",
          backgroundColor:"white",
          flex: 0,
          py: 0,
          px: 2,
          boxShadow: "rgb(87 99 113 / 15%) 4px 4px 5px 2px",
          borderRadius: "15px",
        }}
      >
        <div style={{ padding: "0.5rem",flexGrow: 1 }}>
          <StyledTabs
            value={value}
            onChange={handleChange}
            aria-label="styled tabs example"
          >
            <StyledTab label="30RB" />
            <StyledTab label="30RA" />
            <StyledTab label="30XA" />
            <StyledTab label="30XV" />
            <StyledTab label="30XB" />
            <StyledTab label="30GX" />
            <StyledTab label="30RQ" />
            <StyledTab label="30RBM" />
            <StyledTab label="30RBP" />
            <StyledTab label="30RAP" />
            <StyledTab label="HORIZON" />
            <StyledTab label="30KAV" />
          </StyledTabs>
        </div>
      </Box>
    </div>
  );
};

export default DashboardChillerBar;
